import { useSyns } from "../../lib/syns";
import { Shead } from "./Sektion";

// Pilotens fakturor jan–apr 2026, före och efter inlärningen. Siffrorna kommer från databasen och
// räknas som i appen: röd = stoppad för handläggning, gul och grön = redo för attest.
// Första körningen: 337 röda av 1 247. Läget 2026-10-20: 137 röda av 1 249.
const LAGEN = [
  { namn: "Första körningen", text: "Innan agenten hade lärt sig av bokföringen", stoppade: 337, redo: 910 },
  { namn: "I dag", text: "Efter inlärning från bokföringen och justerade kontroller", stoppade: 137, redo: 1112 },
];

const sv = (n: number) => n.toLocaleString("sv-SE");
const pct = (del: number, av: number) => Math.round((del / av) * 100);

export function Piloten() {
  // Staplarna växer fram första gången de syns.
  const ref = useSyns<HTMLDivElement>();
  return (
    <section className="s" id="piloten">
      <div className="wrap">
        <Shead eyebrow="Piloten" rubrik="Från 73 till 89 procent redo för attest"
          hoger={<span className="chip">1 249 leverantörsfakturor, januari till april 2026</span>} />
        <div ref={ref} className="jfr">
          {LAGEN.map((l) => {
            const tot = l.stoppade + l.redo;
            return (
              <div key={l.namn} className="jrad">
                <div className="jt"><b>{l.namn}</b><span>{l.text}</span></div>
                <div className="jstapel">
                  <div className="dist" role="img" aria-label={`${sv(l.redo)} redo för attest och ${sv(l.stoppade)} stoppade, av ${sv(tot)}`}>
                    <span className="klar" style={{ flex: l.redo }} />
                    <span className="rod" style={{ flex: l.stoppade }} />
                  </div>
                  <div className="jtal" aria-hidden="true">
                    <span><b>{pct(l.redo, tot)} %</b> redo för attest</span>
                    <span className="r"><b>{pct(l.stoppade, tot)} %</b> stoppade</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <p className="jnot">Redo för attest betyder gul eller grön. Stoppade fakturor går till handläggning med orsaken angiven. Läget avser 20 oktober 2026.</p>
      </div>
    </section>
  );
}
